<template>
  <tm-skeleton-table
    :rows="rows"
    :columns="columns"
    :header-columns="columns"
    :hide-gradient="hideGradient"
  />
</template>

<script setup lang="ts">
import { getDefaultLoaderColumnsConfig } from '@/composition/table/getDefaultLoaderColumnsConfig'
import { DEFAULT_PER_PAGE } from '@/core/tables/types'
import TmSkeletonTable from '@/components/shared/skeletons/TmSkeletonTable.vue'
import type { TmTableAbstractSkeletonProps } from '@/components/shared/tables/tableBase'

const props = withDefaults(defineProps<TmTableAbstractSkeletonProps>(), {
  hasActions: true,
})
const columns = getDefaultLoaderColumnsConfig()
const rows = props.rowsToDisplay ?? DEFAULT_PER_PAGE
</script>
